import { render, staticRenderFns } from "./RatesListPage.vue?vue&type=template&id=51ae21ac&scoped=true&"
import script from "./RatesListPage.vue?vue&type=script&lang=ts&"
export * from "./RatesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./RatesListPage.vue?vue&type=style&index=0&id=51ae21ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae21ac",
  null
  
)

export default component.exports